// Türkçe karakter dönüşüm haritaları
const turkishToUpperMap = {
  'i': 'İ',
  'ı': 'I',
  'ş': 'Ş',
  'ğ': 'Ğ',
  'ü': 'Ü',
  'ö': 'Ö',
  'ç': 'Ç',
  'İ': 'İ',
  'I': 'I',
  'Ş': 'Ş',
  'Ğ': 'Ğ',
  'Ü': 'Ü',
  'Ö': 'Ö',
  'Ç': 'Ç'
}

const turkishToLowerMap = {
  'İ': 'i',
  'I': 'ı',
  'Ş': 'ş',
  'Ğ': 'ğ',
  'Ü': 'ü',
  'Ö': 'ö',
  'Ç': 'ç',
  'i': 'i',
  'ı': 'ı',
  'ş': 'ş',
  'ğ': 'ğ',
  'ü': 'ü',
  'ö': 'ö',
  'ç': 'ç'
}

function toTurkishUpperCase(char) {
  return turkishToUpperMap[char] || char.toUpperCase()
}

function toTurkishLowerCase(char) {
  return turkishToLowerMap[char] || char.toLowerCase()
}

export default {
  bind(el, binding, vnode) {
    const input = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' ? el : el.querySelector('input, textarea')

    if (input) {
      input.addEventListener('input', function(e) {
        const value = e.target.value
        const capitalizedValue = value
          .split(' ')
          .map(word => {
            if (word.length === 0) return word

            // İlk karakteri büyük harfe çevir (Türkçe destekli)
            const firstChar = toTurkishUpperCase(word.charAt(0))

            // Geri kalan karakterleri küçük harfe çevir (Türkçe destekli)
            const restOfWord = word.slice(1).split('').map(char => toTurkishLowerCase(char)).join('')

            return firstChar + restOfWord
          })
          .join(' ')

        if (value !== capitalizedValue) {
          e.target.value = capitalizedValue
          vnode.componentInstance?.$emit('input', capitalizedValue)
        }
      })
    }
  }
}
